enum PlayerError {
  ADS = 'Ads',
  CAST = 'Cast',
  DOWNLOAD = 'Download',
  DRM = 'DRM',
  FRAGMENT = 'Fragment',
  LOAD = 'Load',
  LOAD_ERROR = 'Load Error',
  MANIFEST = 'Manifest',
  MEDIA = 'Media',
  MEDIASOURCE = 'MediaSource',
  MSS = 'MSS',
  NETWORK = 'Network',
  OFFLINE = 'Offline',
  PLAYER = 'Player',
  PROTECTION = 'Protection',
  SOURCE = 'Source unavailable',
  SOURCEBUFFER = 'SourceBuffer',
  STORAGE = 'Storage',
  STREAMING = 'Streaming',
  SUBTITLES = 'Subtitles',
  SYNCHRONIZATION = 'Synchronization',
  TEXT = 'Text',
  UNKNOWN = 'Unknown',
  UPDATE = 'Update',
  URL = 'URL Resolution',
  MAX_DEVICES = 'MISC.ERRORS.PLAYER.MAX_CONCURRENT_DEVICES',
  GEOBLOCK = 'MISC.ERRORS.PLAYER.GEOBLOCK',
}

enum GeoBlockErrors {
  EUROCOPA = 'eurocopa',
}

const GeoBlockErrorsMessage: { [type: string]: { [lang: string]: string } } = {
  default: {
    es: 'Debido a restricciones geográficas por parte del propietario de los derechos de retransmisión, este contenido no se  puede ver en su zona',
    en: 'This content cannot  be watched in your zone due to restrictions by the owner of the retransmission rights',
    ca: 'Aquest contingut no es pot veure a la seva zona per les restriccions que imposa el propietari dels drets de retransmissió',
  },
  eurocopa: {
    es: 'Debido a restricciones por parte del propietario de los derechos de retransmisión, este contenido se puede ver únicamente dentro del territorio español',
    en: 'This content can only be watched within the Spanish territory due to restrictions by the owner of the retransmission rights',
    ca: 'Aquest contingut només es pot veure dins de l’Estat Espanyol per les restriccions que imposa el propietari dels drets de retransmissió',
  },
};

const CompatibilityError = {
  es: 'La señal de este canal no es compatible con la versión del sistema operativo de tu televisor.',
  en: 'This channel’s signal is not compatible with your TV’s operating system version.',
  ca: 'El senyal d’aquest canal no és compatible amb la versió del sistema operatiu del teu televisor.',
};

enum PlayerState {
  ENDED = 'ended',
  ERROR = 'error',
  IDLE = 'idle',
  LOADED = 'loaded',
  PAUSE = 'pause',
  PLAY = 'play',
  PLAYING = 'playing',
  READY = 'ready',
  SEEK = 'seek',
  SEEKING = 'seeking',
  SEEKED = 'seeked',
  STALLED = 'stalled',
  WAITING = 'waiting',
  FAST_FORWARD = 'fastForward',
  REWIND = 'rewind',
}

enum PlayerType {
  DASHJS = '1',
  HLSJS = '2',
  SHAKA = '3',
  AVPLAYER = '4',
}

enum TimeShift {
  BACKWARDS,
  FORWARD,
}

export {
  PlayerError,
  PlayerState,
  PlayerType,
  TimeShift,
  GeoBlockErrors,
  GeoBlockErrorsMessage,
  CompatibilityError,
};
